import { render, staticRenderFns } from "./RatingTableWrapper.vue?vue&type=template&id=f38b886a&"
import script from "./RatingTableWrapper.vue?vue&type=script&lang=js&"
export * from "./RatingTableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports